import React, { useState, useRef } from 'react';
import { MainContainer, TopContainerWrapper } from './../Recognition/RecognitionActivity/styles';
import PropTypes from "prop-types";
import { Heading } from '../RecogntionAdmin/styles';
import { CoreValuCard, CoreValuContainer } from "../RecogntionAdmin/library/styles";
import RecommendedCard from './recommendedCard'
import {MenuIcon, DemoCategory} from '../../utils/icons'
import {ChallengeHeader} from './style'
import { RightArrow, StarIcon } from '../../utils/icons';
import Slider from "react-slick";
import FeatureChallenge from './featureChallenge'

const Acitivity = ({history}) => {

  const [currentSlide, setActiveTab] = useState(1);
  const sliderRef = useRef(null);

  const recommended = [
    { 
      title: "Morning Yoga", 
      id: 1, 
      color: "#E4888C", 
      backgroundColor: "#EFEFEF", 
      description: "Start your day with a refreshing yoga session. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet.", 
      category_name: "wellness",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Healthy Eating", 
      id: 2, 
      color: "#88C0E4", 
      backgroundColor: "#F0F8FF", 
      description: "Learn the benefits of a balanced diet. Start your day with a refreshing yoga session. Start your day with a refreshing yoga session. Start your day with a refreshing yoga session.", 
      category_name: "nutrition",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Mindfulness Meditation", 
      id: 3, 
      color: "#A3D9A5", 
      backgroundColor: "#EAFBEA", 
      description: "Practice mindfulness to reduce stress and increase focus. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet", 
      category_name: "mental health",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Strength Training", 
      id: 4, 
      color: "#FFB347", 
      backgroundColor: "#FFF5E1", 
      description: "Build muscle and improve endurance with strength exercises. Practice mindfulness to reduce stress and increase focus. Practice mindfulness to reduce stress and increase focus. Practice mindfulness to reduce stress and increase focus", 
      category_name: "fitness",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Hydration Tips", 
      id: 5, 
      color: "#6495ED", 
      backgroundColor: "#E6ECF7", 
      description: "Stay hydrated for better health and performance. Build muscle and improve endurance with strength exercises. Build muscle and improve endurance with strength exercises. Build muscle and improve endurance with strength exercises", 
      category_name: "wellness",
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
      thumbnail_image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    }
  ];

  const featureChallenge = [
    { 
      title: "Morning Yoga", 
      id: 1, 
      description: "Start your day with a refreshing yoga session. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet.", 
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Healthy Eating", 
      id: 2, 
      description: "Learn the benefits of a balanced diet. Start your day with a refreshing yoga session. Start your day with a refreshing yoga session. Start your day with a refreshing yoga session.", 
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    },
    { 
      title: "Mindfulness Meditation", 
      id: 3, 
      description: "Practice mindfulness to reduce stress and increase focus. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet. Learn the benefits of a balanced diet", 
      image: `profile-Image/Avatars/Avatar-${Math.floor(Math.random() * 10) + 1}.png`, // Dynamic image with index
    }
  ];

  const categories = [
    { title: "Classic", id: 1, backgroundColor: "#B1AA56" },
    { title: "Charity", id: 2, backgroundColor: "#DA6C74" },
    { title: "Survivor", id: 3, backgroundColor: "#92A4DA" },
    { title: "Team", id: 4, backgroundColor: "#75B084" },
    { title: "Daily", id: 5, backgroundColor: "#BE7D9C" },
    { title: "Map", id: 6, backgroundColor: "#DA9B6C" },
    { title: "Travel", id: 7, backgroundColor: "#DA6C74" },
    { title: "Bracket", id: 8, backgroundColor: "#DA92C8" },
  ]; 

  const handleBeforeChange = (oldIndex, newIndex) => {
    // Update the current slide index when the slider changes
    setActiveTab(newIndex + 1)
  };

  const FeaturedCompanyRender = (featureChallengesData) => {       
    const settings = {
      dots: false, 
      infinite: true, 
      speed: 500, 
      slidesToShow: 1, 
      slidesToScroll: 1,
      arrows: false,
      beforeChange: handleBeforeChange
    }

    return (
      <div className='first' style={{width:""}}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'baseline', marginBottom:'20px', marginTop:"40px"}}>
          <div>
            <ChallengeHeader style={{color:"#184A61"}}>
              <div className='icon'>{StarIcon()}</div>
              {featureChallengesData && featureChallengesData.length >= 1 ? ("Featured Challenge") : ''}
            </ChallengeHeader>
          </div>
          {featureChallengesData.length > 1 ? (<div style={{display:'flex', alignItems:'center', gap:'15px'}}>
            <button className="slider-arrow-prev" style={{border:"none", background:"#f7f5eb", transform: "rotate(180deg)"}} onClick={() => sliderRef.current.slickPrev()}>
              <RightArrow/>
            </button>
            <span style={{color:'#005c87', fontSize:'18px', fontWeight:400}}>{currentSlide} / {featureChallengesData.length}</span>
            <button className="slider-arrow-next" style={{border:"none",background:"#f7f5eb"}} onClick={() => sliderRef.current.slickNext()}>
              <RightArrow/>
            </button>
          </div>):null}
        </div>
        <div className='singleCardmainFeature' style={{ borderRadius:'6px'}}>
          <Slider className="slick-height" {...settings} ref={sliderRef}>
            {featureChallengesData.map((challenge, index) =>
              <FeatureChallenge
                challenge={challenge}
                key={index}
                history={history}
              />
            )
            }
          </Slider>   
        </div>
      </div>
    )
  };

  return (
    <MainContainer margin>
      <TopContainerWrapper style={{ flexWrap: "wrap" }}>
        <RecommendedCard
          RecommendedEventData={recommended}
          margin="0px"
          isActivity="1"
          history={history}
          RecommendedEventDataLoading={false}
        />
        <Heading isMargin={"40px 0px 20px 0px"}>
          <div className='icon'>
            {MenuIcon()}
          </div>
            Woliba Insights
        </Heading>
        <CoreValuContainer padding="0px" background="transparent" gap="12px 8px">
          <div className="core-values">
            {categories.map((category, index)=>(
              <>
                <CoreValuCard key={index} minwidth="306px" maxwidth="306px" background="white">
                  <div className="core-value-row">
                    <div className="col-one">
                      <div className="icon" style={{background:category.backgroundColor}}>
                        <DemoCategory/>
                      </div>
                      <div className="title">{category?.title} Challenges</div>
                    </div>
                  </div>
                </CoreValuCard>
              </>
            ))}
          </div>
        </CoreValuContainer>
        {FeaturedCompanyRender(featureChallenge)}
      </TopContainerWrapper> 
    </MainContainer>
  );
};

Acitivity.propTypes = {
  getColor: PropTypes.func.isRequired,
  history: PropTypes.object
};

export default Acitivity;